import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { WaybillIdView } from '../../../../models';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { ShipmentWaybillMainInfoState } from './shipment-waybill-main-info.state';
import { Observable } from 'rxjs';
import { ShipmentWaybillEdit, ShipmentWaybillOverview } from '../../models/shipment-waybill.model';
import {
  ShipmentWaybillOverviewEdit,
  ShipmentWaybillOverviewLoad,
  ShipmentWaybillOverviewLoading,
  ShipmentWaybillOverviewSetInitialState,
} from './shipment-waybill-main-info.actions';
import { MatDialogRef } from '@angular/material/dialog';
import { ShipmentWaybillMainInfoEditDialogComponent } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillMainInfoFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentWaybillMainInfoState.getLoaded);
  mainInfo$: Observable<ShipmentWaybillOverview> = this.store.select(ShipmentWaybillMainInfoState.getOverview);

  constructor(private store: Store) {}

  loadAll(identifier: WaybillIdView): void {
    this.store.dispatch(new ShipmentWaybillOverviewLoad(identifier));
  }

  editWaybillMainInfo(
    id: string,
    data: ShipmentWaybillEdit,
    dialogRef: MatDialogRef<ShipmentWaybillMainInfoEditDialogComponent>,
  ): void {
    this.store.dispatch(new ShipmentWaybillOverviewEdit({ id, data, dialogRef }));
  }

  setLoadingState(isLoading: boolean): void {
    this.store.dispatch(new ShipmentWaybillOverviewLoading(isLoading));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentWaybillOverviewSetInitialState());
  }
}
